import React from "react";

import { Link } from "react-router-dom";

interface Props {
  handleLogout: any;
}

const Header: React.FC<Props> = ({ handleLogout }) => {
  //const { handleLogout } = useOutletContext<any>();

  return (
    <div className="header_container">
      <Link className="head_link" to="/mobileadmin">
        Pending
      </Link>
      <Link className="head_link" to="/mobileadmin/stats">
        Stats
      </Link>
      <Link className="head_link" to="/mobileadmin/pastorders">
        Past Orders
      </Link>
      <Link className="head_link" to="/mobileadmin/accounts">
        Accounts
      </Link>

      <button className="move_right" onClick={handleLogout}>
        Log Out
      </button>
    </div>
  );
};

export default Header;
